// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1z4ou","name":"Header_name__JJtd_","birthday":"Header_birthday__3S8NR","skeleton":"Header_skeleton__1QVXx"};